import axios from 'axios';
import { API_BASE_URL as BASE } from './apiConfig';
import { trackEvent } from '@/lib/analytics';

export type FunnelFeature = 'TRIAL' | 'DIAGNOSE';
export type FunnelEventType = 'START' | 'RESULT_SHOWN' | 'SIGNUP_CTA_CLICK';

const apiClient = axios.create({
  baseURL: `${BASE}/api/funnel-events`,
  headers: { 'Content-Type': 'application/json' },
});

/**
 * 무료체험/무료진단 전환 퍼널 이벤트 기록. 자체 DB(funnel_event 테이블)와 Umami에 동시에
 * 기록한다(2026-08-14, Umami는 REACT_APP_UMAMI_WEBSITE_ID 없으면 자동 no-op). 실패해도
 * 사용자 흐름에 영향이 없도록 항상 조용히 무시한다(await 하지 않고 fire-and-forget으로
 * 호출해도 안전).
 */
export async function recordFunnelEvent(
  feature: FunnelFeature,
  eventType: FunnelEventType,
  guestToken?: string | null,
): Promise<void> {
  trackEvent(`${feature.toLowerCase()}_${eventType.toLowerCase()}`, { feature, eventType });
  try {
    await apiClient.post('', { feature, eventType, guestToken: guestToken || undefined });
  } catch {
    // 무시 - 측정 실패가 실제 기능에 영향을 주면 안 됨
  }
}
